module.exports = __webpack_public_path__ + "static/media/defipulse.83853d45.png";